/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function horizontalDrag() {
    var sliders = document.querySelectorAll(".js-grab-scroll");
    sliders.forEach(function (slider) {
        var isDown = false;
        var startX;
        var scrollLeft;
        slider.addEventListener("mousedown", function (e) {
            isDown = true;
            slider.classList.add("cursor-grabbing");
            slider.classList.remove("cursor-grab");
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener("mouseleave", function () {
            isDown = false;
            slider.classList.remove("cursor-grabbing");
            slider.classList.add("cursor-grab");
        });
        slider.addEventListener("mouseup", function () {
            isDown = false;
            slider.classList.remove("cursor-grabbing");
            slider.classList.add("cursor-grab");
        });
        slider.addEventListener("mousemove", function (e) {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - slider.offsetLeft;
            var walk = (x - startX) * 2; //scroll-fast

            slider.scrollLeft = scrollLeft - walk;
        });
    });
}


horizontalDrag();

document.addEventListener('DOMContentLoaded', e => {
    horizontalDrag();
});


/**
 * ------------------------------------------------------------------------------------------------------------
 * REWARDS PAGE TO LOGIN REDIRECT FUNCTIONALITY
 * ------------------------------------------------------------------------------------------------------------
 * 
 * This script redirects users back to the rewards page after they log in.
 * 
 * How it works:
 * 1. When a user visits the rewards page (/pages/rewards), we store this path in sessionStorage
 * 2. When the user goes to the login page, we detect the stored path and add a hidden input 
 *    with name="return_to" to the login form, which Shopify uses to redirect after successful login
 * 3. If the user visits any other page besides rewards or login, we clear the stored path to
 *    prevent unexpected redirects
 */

document.addEventListener('DOMContentLoaded', function() {
    const currentPath = window.location.pathname;

    if (currentPath !== '/pages/rewards' && currentPath !== '/account/login') {
        if (sessionStorage.getItem('loginReturnTo')) {
            sessionStorage.removeItem('loginReturnTo');
        }
        return;
    }

    if (currentPath === '/pages/rewards') {
        sessionStorage.setItem('loginReturnTo', '/pages/rewards');
        
    } else if (currentPath === '/account/login') {
        const savedReturnTo = sessionStorage.getItem('loginReturnTo');
        
        if (savedReturnTo) {
            const loginForm = document.querySelector('form[action*="/account/login"]');
            
            if (loginForm) {
                let input = loginForm.querySelector('input[name="return_to"]');
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'return_to';
                    loginForm.appendChild(input);
                }
                input.value = savedReturnTo;
            } 
        }
    }
});

function updateHeadTagsForPagination(page) {
    // Remove old canonical/meta tags if they exist
    document.querySelectorAll('link[rel="canonical"], meta[name="robots"]').forEach(el => el.remove());
  
    // Build clean canonical URL without tracking parameters
    const url = new URL(window.location.href);
    url.search = ''; // Remove all query parameters
    
    // Only add page parameter if needed
    if (page > 1) {
      url.searchParams.set('page', page);
    }
  
    // Build canonical tag
    const canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', url.toString());
    document.head.appendChild(canonical);
  
    // Add robots tag
    if (page === 2 || page > 2) {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('content', page === 2 ? 'index, follow' : 'noindex, follow');
      document.head.appendChild(meta);
    }
  }
  
  // Run when the page is loaded (useful for direct links like ?page=2)
  document.addEventListener('DOMContentLoaded', function () {
    const page = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    updateHeadTagsForPagination(page);
  });
  
  // Run on browser navigation (back/forward buttons)
  window.addEventListener('popstate', function () {
    const page = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    updateHeadTagsForPagination(page);
  });
  
  // Optional: Run after AJAX pagination if you have a custom event
  document.addEventListener('pagination:page-changed', function (e) {
    const page = parseInt(new URL(e.detail.url).searchParams.get('page') || '1', 10);
    updateHeadTagsForPagination(page);
  });


/**
 * Cart Empty Detection for Klaviyo Tracking
 * Simple and reliable - fires Cart Emptied event when cart goes from 1+ items to 0
 */
(function() {
  let lastKnownItemCount = 0;
  let eventFired = false;

  // Fire the Klaviyo event
  function fireCartEmptiedEvent({ immediate = false } = {}) {
    if (eventFired) return; // Prevent duplicates
    eventFired = true;

    const triggerEvent = () => {
      if (typeof _learnq !== 'undefined') {
        _learnq.push(['track', 'Cart Emptied']);
      } else {
        console.warn('⚠️ Klaviyo library (_learnq) not available. Event not sent.');
      }
    };

    if (immediate) {
      triggerEvent();
    } else {
      setTimeout(triggerEvent, 1500); // Delay so QA can see log before any UI updates
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    lastKnownItemCount = window.Shopify?.cart?.item_count || 0;
    eventFired = lastKnownItemCount === 0 ? false : eventFired;
  });

  // Listen for cart updates
  document.addEventListener('cart:updated', function(event) {
    const cart = event.detail.cart; // Get the updated content of the cart
    const currentCount = cart?.item_count || 0;

    if (cart && currentCount < 1 && lastKnownItemCount > 0) {
      fireCartEmptiedEvent();
    } else if (currentCount > 0) {
      eventFired = false;
    }

    lastKnownItemCount = currentCount;
  });

  // Fallback: cart page form submissions (full page reload)
  document.addEventListener('submit', function(event) {
    const form = event.target;

    if (!form || !form.action || !form.action.includes('/cart')) return;

    const quantityInputs = form.querySelectorAll('input[name*="updates"], input[name="quantity"]');
    let totalQuantity = 0;

    quantityInputs.forEach(function(input) {
      const value = parseInt(input.value, 10);
      const quantity = Number.isFinite(value) ? value : 0;
      totalQuantity += quantity;
    });

    if (totalQuantity === 0 && lastKnownItemCount > 0) {
      fireCartEmptiedEvent({ immediate: true });
    }
  }, true); // capture to run before navigation

  // Reset filters when changing language (localization form) - filter values are locale-specific
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form || form.action?.indexOf('/localization') === -1) return;
    const returnToInput = form.querySelector('input[name="return_to"]');
    if (!returnToInput?.value) return;
    try {
      const returnPath = returnToInput.value.startsWith('/') ? returnToInput.value : '/' + returnToInput.value;
      const url = new URL(returnPath, window.location.origin);
      let hasFilterParams = false;
      for (const key of url.searchParams.keys()) {
        if (key.startsWith('filter.') || key === 'page') {
          url.searchParams.delete(key);
          hasFilterParams = true;
        }
      }
      if (hasFilterParams) {
        returnToInput.value = url.pathname + (url.search ? url.search : '');
      }
    } catch (_) {}
  }, true);

  // Fallback: remove buttons on cart page
  document.addEventListener('click', function(event) {
    const target = event.target.closest('a[href*="remove"], a[href*="quantity=0"], button[name="update"], button[data-cart-remove], .cart__remove, .line-item__remove-button');
    if (!target) return;

    if (lastKnownItemCount === 1) {
      fireCartEmptiedEvent({ immediate: true });
    }
  }, true);
})();
